import { MapOverlayContainer } from '../../../../../app-kit/components/PcaMap/subcomponents/MapOverlayContainer/MapOverlayContainer';
import type { Point } from '../../../../../app-kit/components/PcaMap/types';
import { paletteHelper } from '@property.com.au/ui-kit';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import styled from 'styled-components';
import { PcaMapContext } from '../../../../contexts/PcaMapContext/PcaMapContext';

interface PropertyBoundaryVerticesProps {
  propertyBoundaryVertices?: Point[] | null;
}

const Vertex = styled.div`
  background-color: ${paletteHelper('backgroundBrandStatic')};
  border-radius: 50%;
  width: 6px;
  height: 6px;
`;

export const PropertyBoundaryVertices: FunctionComponent<PropertyBoundaryVerticesProps> = ({
  propertyBoundaryVertices,
}) => {
  const { isLoading, map } = useContext(PcaMapContext);
  return (
    <>
      {!isLoading &&
        map &&
        propertyBoundaryVertices &&
        propertyBoundaryVertices.map((vertex) => {
          return (
            <MapOverlayContainer
              key={`${vertex.latitude},${vertex.longitude}`}
              position={{
                lat: vertex.latitude,
                lng: vertex.longitude,
              }}
              minZoomLevelToDisplayOverlay={18}
              // minZoomLevelToDisplayOverlay is set here to slightly higher than the zoom level at which google maps generally shows
              // building boundaries since measurement labels take up more space than building boundaries.
              // See: https://developers.google.com/maps/documentation/maps-static/start#Zoomlevels
              map={map}
            >
              <Vertex />
            </MapOverlayContainer>
          );
        })}
    </>
  );
};
